import { Controller } from "@hotwired/stimulus"

// Suggests a username from the name as it is typed, the way User.suggested_username does
// on the server (keep the 20 and 5 below in step with User::USERNAME_LENGTH and
// USERNAME_MIN), until the student edits the username themselves. The hidden flag tells
// the server the value is still the suggestion, so a taken one gets a number instead of
// an error.
export default class extends Controller {
  static targets = ["firstName", "lastName", "username", "suggested"]

  // The page starts with the flag off, for a browser without JavaScript. An empty field
  // is the controller's to fill; one already holding a name (a form sent back with an
  // error) keeps whatever the flag said.
  connect() {
    if (this.usernameTarget.value === "") this.suggestedTarget.value = "1"
  }

  suggest() {
    if (this.suggestedTarget.value !== "1") return

    this.usernameTarget.value = this.#fromName()
  }

  edited() {
    this.suggestedTarget.value = "0"
  }

  #fromName() {
    const surname = this.lastNameTarget.value.trim().split(/\s+/)[0] || ""
    const words = `${this.firstNameTarget.value} ${surname}`
      .normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()
      .match(/[a-z0-9]+/g) || []
    const name = words.join(".").slice(0, 20).replace(/\.$/, "")
    return name.length >= 5 ? name : ""
  }
}
